import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

// Components
import * as S from './Styled';
import { useDispatch } from 'react-redux';
import { loadFavoriteProducts } from '../../actions';
import { bodyScrollFix } from '../../utils';
/*import Callback from '../Callback';
import { Beforeunload } from 'react-beforeunload';*/

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.object.isRequired,
    PropTypes.array.isRequired,
  ]),
};

const Main = ({ children, ...rest }) => {
  const dispatch = useDispatch();
  /*  const [callback, setCallback] = useState(false);
  const [callbackModal, setCallbackModal] = useState(false);*/

  useEffect(() => {
    async function fetchData() {
      dispatch(loadFavoriteProducts());
    }

    fetchData();
  }, [dispatch]);

  /*useEffect(() => {
    let timer;
    if (callback) {
      timer = setTimeout(() => {
        setCallbackModal(true);
      }, 1500);
    } else {
      setCallbackModal(false);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [callback]);*/

  useEffect(() => {
    bodyScrollFix();
  }, []);

  /*const onUnload = event => {
    event.preventDefault();
    setCallback(true);
  };*/

  /*const onSubmitData = async form => {
    try {
      console.log(form);
      // await dispatch(submitForm(form);
      setCallbackModal(false);
    } catch (e) {
      console.error(e);
      setCallbackModal(false);
    }
  };*/

  return (
    <>
      <S.Main {...rest}>{children}</S.Main>
      {/* <Beforeunload onBeforeunload={onUnload}>
      </Beforeunload>*/}

      {/*<Callback
        visible={callbackModal}
        onOk={onSubmitData}
        onCancel={() => {
          setCallbackModal(false);
          setCallback(false);
        }}
      />*/}
    </>
  );
};

Main.propTypes = propTypes;

export default Main;
